/* =======================================================================
   Carnforth A/B Tests — shared behavior (Test 1 + Test 2)
   Loaded only on the test template (gated by section settings).
   Vanilla JS to match the theme's existing pattern.
   ======================================================================= */
(function () {
  'use strict';

  /* -----------------------------------------------------------------
     US -> EU mapping + per-size stencil PDF URLs.

     OPEN ITEMS (handoff §10):
       #1 Real per-size stencil CDN URLs — supply via the product metafield
          custom.size_stencils (JSON: { "10": { "eu": "42", "pdf": "https://..." } }).
          Injected into window.CF_SIZE_CONFIG by the section.
       #2 US -> EU mapping — the values below are the prototype's ILLUSTRATIVE
          map and MUST be confirmed against Birchbury's official size chart.

     The metafield (CF_SIZE_CONFIG) always wins; this fallback fills gaps so
     the UI degrades gracefully until the real data is in.
     ----------------------------------------------------------------- */
  var EU_FALLBACK = {
    '5': '37', '6': '38', '7': '39', '8': '40', '9': '41', '10': '42',
    '11': '43', '11.5': '44', '12': '45', '13': '46', '14': '47', '15': '48',
    '16': '49'
  };

  // Real per-EU-size stencil PDFs on Birchbury's Shopify CDN (from the live
  // print-&-trace size table). These are universal across products; the product
  // metafield custom.size_stencils still wins per-size when present.
  // Note: EU 37/38 (US 5/6) have no stencil on file. EU 44 reuses the EU 43 sheet.
  var PDF_FALLBACK = {
    '39': 'https://cdn.shopify.com/s/files/1/0782/4136/6294/files/SIZE_39_compressed.pdf?v=1689316698',
    '40': 'https://cdn.shopify.com/s/files/1/0782/4136/6294/files/SIZE_40.pdf?v=1689317389',
    '41': 'https://cdn.shopify.com/s/files/1/0782/4136/6294/files/SIZE_41_compressed.pdf?v=1689317600',
    '42': 'https://cdn.shopify.com/s/files/1/0782/4136/6294/files/SIZE_42.pdf?v=1689317538',
    '43': 'https://cdn.shopify.com/s/files/1/0782/4136/6294/files/SIZE_43.pdf?v=1689317674',
    '44': 'https://cdn.shopify.com/s/files/1/0782/4136/6294/files/SIZE_43.pdf?v=1689317674',
    '45': 'https://cdn.shopify.com/s/files/1/0782/4136/6294/files/SIZE_45_compressed.pdf?v=1689317825',
    '46': 'https://cdn.shopify.com/s/files/1/0782/4136/6294/files/SIZE_46.pdf?v=1689317838',
    '47': 'https://cdn.shopify.com/s/files/1/0782/4136/6294/files/SIZE_47.pdf?v=1689317905',
    '48': 'https://cdn.shopify.com/s/files/1/0782/4136/6294/files/SIZE_48.pdf?v=1689317919',
    '49': 'https://cdn.shopify.com/s/files/1/0782/4136/6294/files/SIZE_49.pdf?v=1689317990'
  };

  var CONFIG = window.CF_SIZE_CONFIG || {};

  function euFor(us) {
    if (CONFIG[us] && CONFIG[us].eu) return String(CONFIG[us].eu);
    return EU_FALLBACK[us] || '';
  }
  function pdfFor(us) {
    if (CONFIG[us] && CONFIG[us].pdf) return CONFIG[us].pdf;
    return PDF_FALLBACK[euFor(us)] || '';
  }

  /* -----------------------------------------------------------------
     Existing "Find My Size" app (Strut.fit) — TRIGGER, do not rebuild.
     The <strutfit-size-button> renders its own launcher; we forward our
     clicks to it. NOTE: confirm the exact open mechanism on the live site
     during QA (handoff §10 #5) — adjust the selector below if needed.
     ----------------------------------------------------------------- */
  function strutfitEl() {
    return document.querySelector('strutfit-size-button');
  }

  // Product code Strut.fit was configured with (the <strutfit-size-button product-code>).
  function strutfitProductCode() {
    if (window.CF_STRUTFIT_PRODUCT_CODE != null && window.CF_STRUTFIT_PRODUCT_CODE !== '') {
      return String(window.CF_STRUTFIT_PRODUCT_CODE);
    }
    var host = strutfitEl();
    return host ? (host.getAttribute('product-code') || '') : '';
  }

  // Open the existing Find My Size widget via Strut.fit's JS API.
  // (Strut.fit's own size button calls window.StrutFit.openAssistant("sizing", code).)
  function openStrutFit(code) {
    if (window.StrutFit && typeof window.StrutFit.openAssistant === 'function') {
      window.StrutFit.openAssistant('sizing', code);
      return true;
    }
    return false;
  }

  function triggerFindMySize() {
    var code = strutfitProductCode();
    if (openStrutFit(code)) return;

    // API not ready yet (scripts still loading) — open as soon as it is, and
    // poll briefly as a backstop. Last resort: click Strut.fit's real element.
    var done = false;
    var finish = function () { if (!done && openStrutFit(code)) done = true; return done; };
    document.addEventListener('strutfit:ready', finish, { once: true });
    var tries = 0;
    var iv = setInterval(function () {
      if (finish() || ++tries > 40) { // ~4s
        clearInterval(iv);
        if (!done) {
          var host = strutfitEl();
          if (host) {
            var t = (host.shadowRoot && host.shadowRoot.querySelector('button, a, [role="button"]')) || host;
            t.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
          } else {
            console.warn('[cf-ab] Strut.fit not available (window.StrutFit / <strutfit-size-button> missing).');
          }
        }
      }
    }, 100);
  }

  /* -----------------------------------------------------------------
     Print & trace modal
     ----------------------------------------------------------------- */
  function initModal() {
    var overlay = document.querySelector('[data-cf-guide]');
    if (!overlay) return;

    var modal = overlay.querySelector('.cf-guide-modal');
    var closeBtn = overlay.querySelector('[data-cf-close]');
    var pills = Array.prototype.slice.call(overlay.querySelectorAll('.cf-pill'));
    var segBtns = Array.prototype.slice.call(overlay.querySelectorAll('.cf-seg-btn'));
    var readyEl = overlay.querySelector('[data-cf-ready]');
    var sizeEl = overlay.querySelector('[data-cf-size-label]');
    var printBtn = overlay.querySelector('[data-cf-print]');
    var scanInsteadBtn = overlay.querySelector('[data-cf-scan-instead]');

    var fit = 'snug';
    var selUS = null;
    var lastFocused = null;

    // Toe-room readout for the print bar. The step-3 instruction text lives in the
    // markup (both copies, toggled by [data-fit] in CSS) to avoid layout shift.
    var FIT = {
      snug: { toe: '≈ 1 cm toe room' },
      relaxed: { toe: '≈ 1.5 cm toe room' }
    };

    /* Fill EU labels on each pill from the config/fallback. */
    pills.forEach(function (pill) {
      var us = pill.getAttribute('data-us');
      var euSlot = pill.querySelector('.cf-pill-eu');
      var eu = euFor(us);
      if (euSlot) euSlot.textContent = eu ? 'EU ' + eu : '';
      else if (!eu) { /* no EU known yet */ }
    });

    function render() {
      var us = selUS;
      var eu = us ? euFor(us) : '';
      if (readyEl) readyEl.textContent = 'Ready to print — ' + fit + ' fit · ' + FIT[fit].toe;
      overlay.setAttribute('data-fit', fit); // CSS swaps the (pre-rendered) step-3 copy; no layout shift

      pills.forEach(function (p) { p.classList.toggle('is-sel', p.getAttribute('data-us') === us); });
      segBtns.forEach(function (b) { b.classList.toggle('is-sel', b.getAttribute('data-fit') === fit); });

      if (us) {
        var pdf = pdfFor(us);
        if (sizeEl) {
          sizeEl.textContent = pdf
            ? 'US ' + us + (eu ? ' · EU ' + eu : '') + ' stencil'
            : 'No printable stencil for US ' + us + (eu ? ' · EU ' + eu : '');
        }
        if (printBtn) {
          if (pdf) {
            printBtn.setAttribute('href', pdf);
            printBtn.setAttribute('aria-disabled', 'false');
          } else {
            printBtn.removeAttribute('href');
            printBtn.setAttribute('aria-disabled', 'true');
          }
        }
      } else {
        if (sizeEl) sizeEl.textContent = 'Select a size to print';
        if (printBtn) { printBtn.removeAttribute('href'); printBtn.setAttribute('aria-disabled', 'true'); }
      }
    }

    /* Default the selected pill to the current buy-box size, if any. */
    function currentBuyBoxSize() {
      var label = document.getElementById('cfab-selected-size');
      var raw = label ? label.textContent.trim() : '';
      if (!raw) {
        var active = document.querySelector('.cfab-size-btn.active');
        raw = active ? active.getAttribute('data-value') : '';
      }
      return raw ? raw.split(' ')[0] : '';
    }

    pills.forEach(function (pill) {
      pill.addEventListener('click', function () {
        selUS = pill.getAttribute('data-us');
        render();
      });
    });
    segBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        fit = btn.getAttribute('data-fit') || 'snug';
        render();
      });
    });

    /* --- focus trap --- */
    function focusables() {
      return Array.prototype.slice.call(modal.querySelectorAll(
        'a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])'
      )).filter(function (el) { return el.offsetParent !== null; });
    }
    function onKeydown(e) {
      if (e.key === 'Escape') { close(); return; }
      if (e.key !== 'Tab') return;
      var f = focusables();
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }

    function open() {
      lastFocused = document.activeElement;
      var bb = currentBuyBoxSize();
      if (bb && pills.some(function (p) { return p.getAttribute('data-us') === bb; })) selUS = bb;
      else if (!selUS && pills.length) selUS = pills[0].getAttribute('data-us');
      render();
      overlay.hidden = false;
      document.body.style.overflow = 'hidden';
      document.addEventListener('keydown', onKeydown);
      var f = focusables();
      if (f.length) f[0].focus();
    }
    function close() {
      overlay.hidden = true;
      document.body.style.overflow = '';
      document.removeEventListener('keydown', onKeydown);
      if (lastFocused && lastFocused.focus) lastFocused.focus();
    }

    overlay.addEventListener('click', function (e) { if (e.target === overlay) close(); });
    if (closeBtn) closeBtn.addEventListener('click', close);
    if (scanInsteadBtn) scanInsteadBtn.addEventListener('click', function () {
      close();
      triggerFindMySize();
    });

    /* expose for triggers elsewhere (finder card, sticky bar, FAQ) */
    window.CF = window.CF || {};
    window.CF.openPrintGuide = open;
    window.CF.closePrintGuide = close;
    window.CF.triggerFindMySize = triggerFindMySize;
  }

  /* -----------------------------------------------------------------
     Global triggers: any [data-cf-open="print"|"scan"] opens the right tool.
     ----------------------------------------------------------------- */
  function initTriggers() {
    document.addEventListener('click', function (e) {
      var t = e.target.closest('[data-cf-open]');
      if (!t) return;
      e.preventDefault();
      var which = t.getAttribute('data-cf-open');
      if (window.CF && window.CF.closeStickyPanels) window.CF.closeStickyPanels();
      if (which === 'print' && window.CF && window.CF.openPrintGuide) window.CF.openPrintGuide();
      else if (which === 'scan') triggerFindMySize();
    });
  }

  /* -----------------------------------------------------------------
     Content-bug fix (§3.5): point the "...without a printer" FAQ at the
     restored Print & trace guide by appending a trigger button to its answer.
     Matched by text so it survives copy tweaks.
     ----------------------------------------------------------------- */
  function initFaqFix() {
    if (!document.querySelector('[data-cf-guide]')) return;
    var triggers = document.querySelectorAll('.cfab-faqs-section .cfab-accordion-trigger');
    Array.prototype.forEach.call(triggers, function (trg) {
      var q = (trg.textContent || '').toLowerCase();
      if (q.indexOf('without a printer') === -1 && q.indexOf('determine my shoe size') === -1) return;
      var item = trg.closest('.cfab-accordion-item');
      var body = item && item.querySelector('.cfab-accordion-body');
      if (!body || body.querySelector('.cf-faq-guide-link')) return;
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'cf-faq-guide-link';
      btn.setAttribute('data-cf-open', 'print');
      btn.innerHTML = '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M6 9V3h12v6"/><rect x="4" y="9" width="16" height="8" rx="1.5"/><path d="M7 17h10v4H7z"/></svg> Open the Print &amp; trace guide';
      body.appendChild(btn);
    });
  }

  /* -----------------------------------------------------------------
     TEST 2 — Sticky Add-to-Cart bar.
     Single source of truth = the main buy box (#cfab-product-form). We drive
     it by activating the real .cfab-size-btn, and mirror its state back into
     the bar(s). ATC submits the same product form.
     ----------------------------------------------------------------- */
  /* Reveal rules for the bar:
       'all'  -> always (or when the section set no mode, i.e. Test 2)
       'ab'   -> only when the Mida variation param ?sticky_atc=1 is present
       'off'  -> the section renders no bar at all, so we never get here */
  function stickyEnabled() {
    if (window.CF_STICKY_MODE !== 'ab') return true;
    try {
      return new URL(window.location.href).searchParams.has('sticky_atc');
    } catch (e) {
      return /[?&]sticky_atc(=|&|$)/.test(window.location.search);
    }
  }

  function initSticky() {
    var bars = Array.prototype.slice.call(document.querySelectorAll('[data-cf-sticky]'));
    if (!bars.length || !stickyEnabled()) return;

    var form = document.getElementById('cfab-product-form');
    var mainAtc = document.getElementById('cfab-add-to-cart');
    var priceEl = document.getElementById('cfab-current-price');
    var sizeLabelEl = document.getElementById('cfab-selected-size');
    var colorLabelEl = document.getElementById('cfab-selected-color');
    var mainImg = document.getElementById('cfab-main-img');
    if (!form) return;

    /* Fill EU labels on the sticky size cells. */
    Array.prototype.forEach.call(document.querySelectorAll('[data-cf-sizecell]'), function (cell) {
      var euSlot = cell.querySelector('.cf-sizecell-eu');
      var eu = euFor(cell.getAttribute('data-us'));
      if (euSlot) euSlot.textContent = eu ? 'EU ' + eu : '';
    });

    function currentUS() {
      var raw = sizeLabelEl ? sizeLabelEl.textContent.trim() : '';
      if (!raw) {
        var active = document.querySelector('.cfab-size-btn.active');
        raw = active ? active.getAttribute('data-value') : '';
      }
      return raw ? raw.split(' ')[0] : '';
    }

    /* --- mirror main buy box -> sticky bar(s) --- */
    function sync() {
      var us = currentUS();
      var eu = us ? euFor(us) : '';
      var price = priceEl ? priceEl.textContent.trim() : '';
      var soldOut = mainAtc ? mainAtc.disabled : false;
      var color = colorLabelEl ? colorLabelEl.textContent.trim() : '';

      document.querySelectorAll('.cf-sticky-size-us').forEach(function (n) { n.textContent = us ? 'US ' + us : 'Select size'; });
      document.querySelectorAll('.cf-sticky-size-eu').forEach(function (n) { n.textContent = eu ? 'EU ' + eu : ''; });
      if (price) document.querySelectorAll('.cf-sticky-price').forEach(function (n) { n.textContent = price; });
      document.querySelectorAll('.cf-sticky-cart').forEach(function (n) {
        n.disabled = soldOut;
        n.textContent = soldOut ? 'SOLD OUT' : 'ADD TO CART';
      });
      if (color) document.querySelectorAll('.cf-sticky-desc').forEach(function (n) { n.textContent = color + ' leather'; });
      if (mainImg && mainImg.src) document.querySelectorAll('.cf-sticky-thumb').forEach(function (n) { n.src = mainImg.src; });

      /* selected state on sticky size cells */
      var activeMain = document.querySelector('.cfab-size-btn.active');
      var activeVal = activeMain ? activeMain.getAttribute('data-value') : '';
      document.querySelectorAll('[data-cf-sizecell]').forEach(function (cell) {
        cell.classList.toggle('is-sel', cell.getAttribute('data-value') === activeVal);
        /* reflect sold-out availability from the matching main button */
        var main = document.querySelector('.cfab-size-btn[data-value="' + cssEscape(cell.getAttribute('data-value')) + '"]');
        var unavailable = main ? main.classList.contains('sold-out') : false;
        cell.disabled = unavailable;
      });
    }

    function cssEscape(v) {
      return (v || '').replace(/["\\]/g, '\\$&');
    }

    /* --- sticky size pick -> drive the real selector --- */
    document.querySelectorAll('[data-cf-sizecell]').forEach(function (cell) {
      cell.addEventListener('click', function () {
        if (cell.disabled) return;
        var val = cell.getAttribute('data-value');
        var main = document.querySelector('.cfab-size-btn[data-value="' + cssEscape(val) + '"]');
        if (main) main.click(); // runs the theme's existing variant logic
        closeAllPanels();
        // sync() will fire via the MutationObserver, but call once for snappiness
        sync();
      });
    });

    /* --- popover open/close per bar --- */
    function closeAllPanels() {
      document.querySelectorAll('[data-cf-pop]').forEach(function (p) { p.hidden = true; });
      document.querySelectorAll('[data-cf-size-toggle],[data-cf-finder-toggle]').forEach(function (t) {
        t.classList.remove('is-open');
        t.setAttribute('aria-expanded', 'false');
      });
    }
    function togglePanel(bar, name, toggleBtn) {
      var pop = bar.querySelector('[data-cf-pop="' + name + '"]');
      if (!pop) return;
      var willOpen = pop.hidden;
      closeAllPanels();
      if (willOpen) {
        pop.hidden = false;
        if (toggleBtn) { toggleBtn.classList.add('is-open'); toggleBtn.setAttribute('aria-expanded', 'true'); }
      }
    }

    bars.forEach(function (bar) {
      var sizeToggle = bar.querySelector('[data-cf-size-toggle]');
      var finderToggle = bar.querySelector('[data-cf-finder-toggle]');
      if (sizeToggle) sizeToggle.addEventListener('click', function (e) { e.stopPropagation(); togglePanel(bar, 'size', sizeToggle); });
      if (finderToggle) finderToggle.addEventListener('click', function (e) { e.stopPropagation(); togglePanel(bar, 'finder', finderToggle); });
    });
    // tap outside (but not dead-space inside a popover/toggle) dismisses any open popover
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-cf-pop], [data-cf-size-toggle], [data-cf-finder-toggle]')) return;
      closeAllPanels();
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAllPanels(); });

    // let other handlers (e.g. finder buttons opening a tool) close the popovers
    window.CF = window.CF || {};
    window.CF.closeStickyPanels = closeAllPanels;

    /* --- ATC: submit the real product form --- */
    document.querySelectorAll('[data-cf-sticky-cart]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.disabled) return;
        if (typeof form.requestSubmit === 'function') form.requestSubmit();
        else form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
      });
    });

    /* --- mirror main -> sticky on any variant change --- */
    var mo = new MutationObserver(sync);
    [priceEl, sizeLabelEl, colorLabelEl].forEach(function (n) {
      if (n) mo.observe(n, { childList: true, characterData: true, subtree: true });
    });
    if (mainAtc) mo.observe(mainAtc, { attributes: true, childList: true, characterData: true, subtree: true });
    if (mainImg) mo.observe(mainImg, { attributes: true, attributeFilter: ['src'] });
    // also catch size-button clicks directly (covers .active class toggles)
    document.querySelectorAll('.cfab-size-btn, .cfab-color-swatch').forEach(function (b) {
      b.addEventListener('click', function () { setTimeout(sync, 0); });
    });

    /* --- reveal once the buy box scrolls out of view --- */
    var sentinel = mainAtc || form;
    function setVisible(v) { bars.forEach(function (bar) { bar.classList.toggle('is-visible', v); }); if (!v) closeAllPanels(); }
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        var e = entries[0];
        // show only when the buy box has scrolled ABOVE the viewport
        setVisible(!e.isIntersecting && e.boundingClientRect.top < 0);
      }, { threshold: 0, rootMargin: '0px 0px -40px 0px' });
      io.observe(sentinel);
    }

    sync();
  }

  function init() {
    initModal();
    initTriggers();
    initFaqFix();
    initSticky();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
